import React from "react";
import Typography from "@material-ui/core/Typography";

interface ErrorMessageProps {
    message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = (props) => {
    return <Typography color={"error"}>{props.message}</Typography>
};

export default ErrorMessage;
